"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _conf = _interopRequireDefault(require("../../conf"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var street = function street(val, row) {
  return /*#__PURE__*/_react.default.createElement("span", null, row.street);
};

var location = function location(val, row) {
  return /*#__PURE__*/_react.default.createElement("span", null, row.zip, " ", row.city);
};

var FarmList = /*#__PURE__*/function (_React$Component) {
  _inherits(FarmList, _React$Component);

  function FarmList(props) {
    var _this;

    _classCallCheck(this, FarmList);

    _this = _possibleConstructorReturn(this, (FarmList.__proto__ || Object.getPrototypeOf(FarmList)).call(this, props));
    _this.state = {
      farmData: [],
      isLoading: false
    };
    _this.renderDetailLink = _this.renderDetailLink.bind(_assertThisInitialized(_this));
    _this.load = _this.load.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FarmList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var columns = [{
        title: '',
        render: this.renderDetailLink
      }, {
        title: t('first name'),
        prop: 'first_name'
      }, {
        title: t('last name'),
        prop: 'last_name'
      }, {
        title: t('farm'),
        prop: 'farmname'
      }, {
        title: t('street'),
        render: street,
        prop: 'street'
      }, {
        title: t('city'),
        render: location,
        prop: 'zip'
      }];
      var staticTexts = {
        search: t('search'),
        noData: t('no data'),
        loading: t('loading data'),
        all: t('all'),
        pageSize: t('results per page')
      };
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, t('farms')), /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id'],
        isLoading: this.state.isLoading,
        columns: columns,
        initialData: this.state.farmData,
        staticTexts: staticTexts,
        loadData: this.load,
        useLocalStorage: true
      }));
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "renderDetailLink",
    value: function renderDetailLink(val, row) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: "/farm/".concat(row.id),
        title: this.props.t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
    /**
     *
     */

  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.farmRegistrations(this.props.i18n.language), {
        credentials: 'include'
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return _this2.setState({
          farmData: json,
          isLoading: false
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }]);

  return FarmList;
}(_react.default.Component);

FarmList.propTypes = {
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(FarmList);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/farm-list/index.js
// module id = 738
// module chunks = 0